import script from "./MatchdButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchdButton.vue?vue&type=script&setup=true&lang=ts"

import "./MatchdButton.vue?vue&type=style&index=0&id=41837c62&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41837c62"]])

export default __exports__